export default {
  data () {
    return {
      currentPage: 1,
      pageSize: 10,
      totalCount: 0,
      tableData: [],
      tableLoading: false
    }
  },

  mounted () {
    // this.getList()
  },

  methods: {
    // 初始化一个方法，防止报错
    getList () {},

    pageChange (page) {
      this.currentPage = page
      this.getList()
    },

    pageSizeChange (size) {
      this.pageSize = size
      this.currentPage = 1
      this.getList()
    }
  }
}
